import axios from "axios";
import AuthService from "../login/auth.service";
import { solicitudes } from "../../components/generico/utils/UrlAPI";


class PrestamoService {

    async getTiposPrestamos() {

        var config = {
          method: "get",
          url: solicitudes + 'solicitudes/tipoDato',
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + AuthService.getCurrentToken(),
          },
          
        };
    
        return await axios(config);
      }

      async confirmarSolicitud(monto, plazo, destino, telefono, email) {
        var usuario = AuthService.getSocio();

        var data = JSON.stringify({
          numeroSocio: usuario.numeroSocio,
          monto: monto,
          plazo: plazo,
          destino: destino,
          tipoServicio: "C",
          canalCarga: "W",
          estado:"P",
          telContactoCel: telefono,
          email: email,
        });
       
        var config = {
          method: "post",
          url: solicitudes + 'solicitudes/creditos',
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + AuthService.getCurrentToken(),
          },
          data: data,
          timeout: 60000
        };
       
        return await axios(config);
      }
}



export default new PrestamoService();